import { BrowserRouter } from 'react-router-dom';
import Layout from '../shared/components/layout/Layout';
import { AppRoutes } from '../router';

const BASE_PATH = import.meta.env.BASE_URL || '/';

function App() {
  return (
    <BrowserRouter basename={BASE_PATH}>
      <Layout>
        <AppRoutes />
      </Layout>
    </BrowserRouter>
  );
}

export default App;
